
import {apiClient} from './util';
import {AxiosPromise} from 'axios';


export default {
    lock_user: (token: string): AxiosPromise => apiClient.post("/user/credentials/block/?token=" + token),
};
